// 📄 programaZService.ts
// Catálogo de Programas/Includes ABAP personalizados (desarrollos Z) por
// proyecto — mismo patrón de acceso que badiZService.ts: Firestore DIRECTO
// desde el cliente (colección projects/{projectId}/programasZ), protegido
// por firestore.rules (mismo criterio exacto que badisZ/transaccionesZ).
import {
  collection,
  doc,
  getDocs,
  setDoc,
  updateDoc,
  deleteDoc,
  serverTimestamp,
  Timestamp
} from "firebase/firestore";
import { db } from "../firebase";
import { SolucionBadi } from "./catalogoBadisService.ts";
import { SistemaAmbiente } from "./transaccionZService.ts";

export interface ProgramaZData {
  nombre: string;
  nombreTecnico: string;
  descripcion: string;
  solucion: SolucionBadi;
  badiRefIds: string[];
  transaccionRefIds: string[];
  responsable: string;
  sistemasDisponibles: SistemaAmbiente[];
  fechaImplementacion: Timestamp | null;
  rolPermiso: string;
  notas: string;
}

export interface ProgramaZ extends ProgramaZData {
  id: string;
  creadoPor: string;
  creadoEn: any;
  actualizadoEn: any;
}

const programasZRef = (projectId: string) => collection(db, "projects", projectId, "programasZ");
const programaZRef = (projectId: string, id: string) => doc(db, "projects", projectId, "programasZ", id);

export const getProgramasZ = async (projectId: string): Promise<ProgramaZ[]> => {
  const snap = await getDocs(programasZRef(projectId));
  return snap.docs
    .map((d) => ({ id: d.id, ...(d.data() as Omit<ProgramaZ, "id">) }))
    .sort((a, b) => a.nombre.localeCompare(b.nombre));
};

export const crearProgramaZ = async (projectId: string, data: ProgramaZData, creadoPor: string): Promise<string> => {
  if (!data.nombre.trim()) throw new Error("El nombre es obligatorio.");

  const ref = doc(programasZRef(projectId));
  await setDoc(ref, {
    ...data,
    nombre: data.nombre.trim(),
    creadoPor,
    creadoEn: serverTimestamp(),
    actualizadoEn: serverTimestamp()
  });
  return ref.id;
};

export const actualizarProgramaZ = async (projectId: string, id: string, data: ProgramaZData): Promise<void> => {
  if (!data.nombre.trim()) throw new Error("El nombre es obligatorio.");

  await updateDoc(programaZRef(projectId, id), {
    ...data,
    nombre: data.nombre.trim(),
    actualizadoEn: serverTimestamp()
  });
};

export const eliminarProgramaZ = async (projectId: string, id: string): Promise<void> => {
  await deleteDoc(programaZRef(projectId, id));
};
